import { Dialog } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { formatCents } from '@/lib/format-currency';
import {
  useDepositLimitGateOpen,
  useDepositLimitGateWindow,
  useDepositLimitGateLimitCents,
  useDepositLimitGateRemainingCents,
  useCloseDepositLimitGate,
} from '@/store/depositLimitGateStore';
import type { DepositLimitWindow } from '@/lib/depositLimit/types';

const WINDOW_LABEL: Record<DepositLimitWindow, string> = { DAILY: 'daily', WEEKLY: 'weekly', MONTHLY: 'monthly' };

/**
 * Deposit-limit popup (CP-007b). Mount once in the app shell. Driven by the
 * deposit-limit gate store, opened by the 403 DEPOSIT_LIMIT_EXCEEDED interceptor.
 * Dismissable — the player can keep browsing; only the over-cap deposit is blocked.
 */
export function DepositLimitGate() {
  const open = useDepositLimitGateOpen();
  const window = useDepositLimitGateWindow();
  const limitCents = useDepositLimitGateLimitCents();
  const remainingCents = useDepositLimitGateRemainingCents();
  const close = useCloseDepositLimitGate();

  if (!open || !window) return null;
  const label = WINDOW_LABEL[window];

  return (
    <Dialog open onClose={close} size="md">
      <div className="flex flex-col gap-4 text-center">
        <h2 className="text-lg font-semibold text-primary">Deposit limit reached</h2>
        <p className="text-sm text-muted">
          You’ve reached your {label} deposit limit
          {typeof limitCents === 'number' ? ` of ${formatCents(limitCents)}` : ''}.
          {typeof remainingCents === 'number' && remainingCents > 0
            ? ` You have ${formatCents(remainingCents)} left to deposit in this period.`
            : ' Try again once the period resets, or contact support.'}
        </p>
        <Button onClick={close} className="w-full">
          Got it
        </Button>
      </div>
    </Dialog>
  );
}
